import React from 'react';
import { Button } from "semantic-ui-react";

const DetailsButton = (props) => {
    const { loading, onClick, disabled } = props;
    return <Button icon="info" size={props.size} loading={loading} onClick={onClick} content="Details" color="blue" disabled={disabled || loading } floated={props.floated} compact={props.compact} />
}

export default DetailsButton;